import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { ContactShadows } from "@react-three/drei";
import {
  RealisticShip,
  RealisticPlane,
  RealisticTruck,
  RealisticContainer,
} from "./RealisticModels";

const SAFFRON = "#FF5500";
const GOLD    = "#FFD700";

// No rotation, no float — pure static showcase display
function StaticModel({ mode }) {
  return (
    <>
      {mode === "ship"      && <RealisticShip      scale={1.0} />}
      {mode === "plane"     && <RealisticPlane     scale={1.0} />}
      {mode === "truck"     && <RealisticTruck     scale={1.0} />}
      {mode === "container" && <RealisticContainer scale={1.0} />}
    </>
  );
}

export default function TransportViewer({ mode }) {
  return (
    <Canvas
      camera={{ position: [0, 0, 2.8], fov: 42 }}
      dpr={[1, 1.5]}
      gl={{
        alpha: true,
        antialias: true,
        powerPreference: "high-performance",
        precision: "mediump",
      }}
    >
      {/* Lights — front-facing so the image pops clearly */}
      <ambientLight intensity={2.2} />
      <directionalLight position={[0, 0, 5]} intensity={2.5} color="#ffffff" />
      <directionalLight position={[5, 5, 3]} intensity={1.8} color={GOLD} />

      <Suspense fallback={null}>
        <StaticModel mode={mode} />
      </Suspense>
    </Canvas>
  );
}
